import { render, staticRenderFns } from "./ReviewsShortsPopupPc.vue?vue&type=template&id=fd87707c&scoped=true"
import script from "./ReviewsShortsPopupPc.vue?vue&type=script&lang=js"
export * from "./ReviewsShortsPopupPc.vue?vue&type=script&lang=js"
import style0 from "./ReviewsShortsPopupPc.vue?vue&type=style&index=0&id=fd87707c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd87707c",
  null
  
)

export default component.exports